import type { DexDocumentType } from "#graphql/supergraphTypes";

/**
 * Test-environment catalog base (host + `data_fabric_test` schema, through `.gold`).
 * The default is TEST only — consumers must override `catalogBaseUrl` in production;
 * threading it through DexApp is a follow-up.
 */
export const DEFAULT_CATALOG_BASE_URL =
  "https://data-catalog.test.junipersquare.us/table/redshift-df-reporting.data_fabric_test.gold";

export type CatalogView = "schema" | "lineage";

// dex_<type> embeds the document type; a new DexDocumentType works automatically
// as long as its catalog table follows the dex_<type> naming convention.
export const buildCatalogUrl = (
  baseUrl: string,
  documentType: DexDocumentType,
  view: CatalogView,
): string => `${baseUrl}.dex_${documentType.toLowerCase()}/${view}`;
